import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

/**
 * Valid PageTypes and SubPageTypes can be found here:
 * https://code.amazon.com/packages/DigitalVideoWebMason/blobs/d8cc03ccaef33fcd35582206bc0abdf8816207c2/--/mason/retail/gp/video/ajax/analytics.m#L8
 */
export function logRefTag(refTag: string, pageType?: WpsRuntime.atv.wps.PageType, subPageType?: WpsRuntime.atv.wps.SubPageType) {
  const endpoint = '/gp/video/ajax/analytics.html/ref='
  fetch(
  `${endpoint}${refTag}${pageType ? `?pageType=${pageType}` : ''}${pageType && subPageType ? `&subPageType=${subPageType}` : ''}`,
  { method: 'POST' }
  )
}

export interface IRecordRefTagProps {
  refTag?: string
  pageType?: WpsRuntime.atv.wps.PageType
  subPageType?: WpsRuntime.atv.wps.SubPageType
  children?: JSX.Element
  className?: string
}

export const RecordRefTag = ({
  refTag,
  pageType,
  subPageType,
  children,
  className = ''
}: IRecordRefTagProps) =>
  !refTag ? (
    <>children</>
  ) : (
    <span
      className={className}
      onClick={() => logRefTag(refTag, pageType, subPageType)}>
      {children}
    </span>
  )
